import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { OrdersTable } from "../../Components/Organisms";
import { Button } from "@chakra-ui/react";
import { AddIcon } from "../../Assets/images/svgs";
import { useNavigate, useSearchParams } from "react-router-dom";
import PATHS from "../../Routes/paths";
import { LastOrder } from "../../Widgets";
import { getShipmentDetails } from "../../APIs";
import { SHIPMENT_STATUS, SHIPPING_STATUSES, SPN_IDS_MAP } from "../../Library/constants";
import { getDate } from "../../Library/datetime";
import { jsonToCSVConvertor } from "../../Library/jsonUtils";

const ShipmentOverview = () => {
  const navigate = useNavigate();
  const [ searchParams ] = useSearchParams();
  const SHIP_ID = useRef(searchParams.get("shipId"));

  const [ shipmentData, setShipmentData ] = useState({});
  const [ selectedShipments, setSelectedShipments ] = useState([]);
  const [ shipmentWithImeis, setShipmentWithImeis ] = useState([]);
  const [ showDownloadLoader, setShowDownloadLoader ] = useState(false);
  const [ prefix, setPrefix ] = useState("");

  useEffect(() => {
    getShipmentDetails(SHIP_ID.current || null, null, null, [], (err, data) => {
      if (err) console.error(err);
      else {
        if (!data || !data.orders || !data.orders.length) return setShipmentData({ prefix: "", orders: [] });

        data.orders.forEach(order => {
          if (order.os && order.os.length) {
            let latestStat = order.os[order.os.length - 1];
            if (latestStat && latestStat.stat) {
              if (latestStat.stat !== SHIPPING_STATUSES["Shipped"] && latestStat.stat !== SHIPPING_STATUSES["Delivered"]) order.disabled = true;
            }
          }
        });
        setShipmentData(data);
        setPrefix(data.prefix || "");
      }
    })
  }, []);

  const handleRowSelect = (selectedRows) => {
    setSelectedShipments(selectedRows);
  }

  function getShipmentStatus(shipment) {
    if (shipment.os && shipment.os.length) {
      const lastStatus = shipment.os[shipment.os.length - 1];
      if (lastStatus && lastStatus.stat && SHIPMENT_STATUS[lastStatus.stat]) {
        return SHIPMENT_STATUS[lastStatus.stat];
      }
    }
    return "-";
  }

  const processDownload = (requestedShipments) => {
    let filteredData = requestedShipments.filter(row => !row.disabled);
    let excelData = [];
    let counter = 0;

    if (!filteredData || !filteredData.length) return;

    filteredData.forEach(shipment => {
      if (!shipment.imeis || !shipment.imeis.length) return;

      shipment.imeis.forEach(data => {
        counter++;
        let obj = {};

        obj["Sr No"] = counter;
        obj["Shipment ID"] = shipment.orderId || "-";
        obj["Shipment Date"] = getDate(shipment.cdt, null, "/") || "-";
        obj["Shipment Status"] = getShipmentStatus(shipment);
        obj["Dealer"] = shipment.dnm || "-";
        obj["IMEI"] = data.imei || "-";
        obj["IMSI"] = data.imsi || "-";
        obj["Carrier"] = data.spnId ? SPN_IDS_MAP[data.spnId] : "-";

        excelData.push(obj);
      });
    });

    var sendData = excelData.map(function (exceldata) {
      var args = "Sr No, Shipment ID, Shipment Date, Shipment Status, Dealer,  IMEI, IMSI, Carrier";
      var filteredData = args.split(",").reduce((mem, arg) => {
        arg = arg.trim();
        mem[arg] = exceldata[arg];
        return mem;
      }, {});
      return filteredData;
    });
    if (sendData.length) jsonToCSVConvertor(sendData, "", true, "MultipleShipments_" + new Date().toLocaleString('en-GB', {month: '2-digit',day: '2-digit',year: 'numeric'}), false);

    setShowDownloadLoader(false);
  }

  const handleDownload = (rowsToDownload) => {
    if (showDownloadLoader) return;

    setShowDownloadLoader(true);
    let requestedShipments = shipmentWithImeis;
    if ((!requestedShipments || !requestedShipments.length) || (requestedShipments.length !== rowsToDownload.length)) {
      getShipmentDetails(SHIP_ID.current || null, null, null, rowsToDownload.map(row => row.original && row.original.orderId), (err, data) => {
        if (err) console.error(err);
        else {
          if (data.orders && data.orders.length) {
            requestedShipments = data.orders;
            setShipmentWithImeis(data.orders);

            processDownload(data.orders);
          }
        }
      });
    } else processDownload(requestedShipments);
  }

  return (
    <section className="panel-main shipment-overview">
      <header className="shipment-overview-header">
        <Button onClick={() => navigate(PATHS.SHIPPING_DETAILS)} className="place-new-order-btn">
          <AddIcon className="new-order-icon" />
          Request Shipment
        </Button>
      </header>
      <div className="last-order shipment">
        {shipmentData.orders && shipmentData.orders.length ? <LastOrder shipmentData={shipmentData} title={"Recent Shipment Status"} isShipmentTimeLine={true} isShipmentOverviewPage={true}/> : null}
      </div>
      {shipmentData.orders && shipmentData.orders.length ? <OrdersTable shipmentData={shipmentData} title={"All Shipments"} shipment={true} onRowSelect={handleRowSelect} onDownload={handleDownload} selectedShipments={selectedShipments} showSelection={true} showSelectAll={true} checkboxLabel={"Select All"} downloadLoader={showDownloadLoader} hideColumn={[]} bulkDownload={true} prefix={prefix}/> : null}
    </section>
  )
}

export default ShipmentOverview
